/**
 * Default scene setup
 * Handles creating the image container and loading the scene image
 */

import { resolveSceneBg, applyResponsiveImage } from '../../../utils/pathResolver'
import type { SceneData } from '../types'

export interface DefaultSceneSetupContext {
  data: SceneData
  container: HTMLDivElement
  onImageLoad: () => void
  onImageError: () => void
}

/**
 * Setup default scene image container and image
 */
export function setupDefaultSceneImage(context: DefaultSceneSetupContext): {
  imageContainer: HTMLDivElement
  img: HTMLImageElement
} {
  // Create image container
  const imageContainer = document.createElement('div')
  imageContainer.className = 'scene__image'
  
  // Apply width if specified (as percentage)
  if (context.data.width !== undefined) {
    imageContainer.style.maxWidth = `${context.data.width}%`
  }

  const bgPath = resolveSceneBg(context.data)
  if (!bgPath) {
    context.container.appendChild(imageContainer)
    return { imageContainer, img: document.createElement('img') }
  }

  const img = document.createElement('img')
  img.src = bgPath
  img.alt = context.data.id
  img.className = 'scene__img'
  img.onload = context.onImageLoad
  img.onerror = context.onImageError
  applyResponsiveImage(img)

  imageContainer.appendChild(img)
  context.container.appendChild(imageContainer)

  return { imageContainer, img }
}
